import { firstValueFrom } from 'rxjs';
import {
  DischargeInfo,
  RequestDto,
} from '../models/request.dto';
import { AuthService } from '../services/auth.service';
import { RequestService } from '../services/request.service';
import { StructureService } from '../services/structure.service';

export async function handleModuloRivalutazioneHospicePreSave(
  api: any,
  request: RequestDto,
  requestDates: DischargeInfo[],
  services: { requestService: RequestService; authService: AuthService; structureService: StructureService }
) {
  const curPall = api?.getFieldModel(
    'scheda_di_prima_valutazione_nella_rete_cure_palliative/scheda_di_prima_valutazione_nella_rete_cure_palliative/modalità_assistenza/tipologie_cure_palliative_domiciliari'
  )?.value[0]?.value;

  const hosp = api?.getFieldModel(
    'scheda_di_prima_valutazione_nella_rete_cure_palliative/scheda_di_prima_valutazione_nella_rete_cure_palliative/modalità_assistenza/tipologie_hospice'
  )?.value[0]?.value;

  const osp = api?.getFieldModel(
    'scheda_di_prima_valutazione_nella_rete_cure_palliative/scheda_di_prima_valutazione_nella_rete_cure_palliative/modalità_assistenza/tipologie_ospedale'
  )?.value[0]?.value;

   const acp = api?.getFieldModel(
    'scheda_di_prima_valutazione_nella_rete_cure_palliative/scheda_di_prima_valutazione_nella_rete_cure_palliative/modalità_assistenza/tipologie_ambulatorio_cure_palliative'
  )?.value[0]?.value;

    const dh = api?.getFieldModel(
    'scheda_di_prima_valutazione_nella_rete_cure_palliative/scheda_di_prima_valutazione_nella_rete_cure_palliative/modalità_assistenza/tipologie_day-hospice'
  )?.value[0]?.value;

  let subsetting = null;
  if(curPall) {
    subsetting = curPall
  } else if (hosp) {
    subsetting = hosp;
  } else if(osp) {
    subsetting = osp;
  } else if (acp) {
    subsetting = acp;
  } else if(dh) {
    subsetting = dh;
  }
  if(curPall) {
    await firstValueFrom(services.requestService.deleteStructureForTransition(request.uuid));
  }
  if(subsetting) {
    await firstValueFrom(services.requestService.changeSetting(request.id, subsetting));
  }

}
